import React from "react";
import { useTranslation } from "react-i18next";
import AppInput from "components/ui/AppInput";
import AppSelect from "components/ui/AppSelect";
import SaveBackButton from "components/ui/SaveBackButton";

const GroupModifierForm = ({
  modifierGroup,
  content,
  handleText = () => {},
  handleSelection = () => {},
  updatePrice = () => {},
  onSave = () => {},
  showBackButton = true,
  as = "create",
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative h-full flex flex-col gap-4">
      <div className='flex-1'>
      <form
        id="createModifierGroupForm"
        className={`relative grid gap-4 ${as === "modal" ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"}`}
      >
        <AppInput
          label={t("Name")}
          value={modifierGroup?.values?.baseLanguage?.name}
          placeholder={t("Enter Modifier Group Name")}
          onInput={(e) => handleText("name", e.target.value)}
          mandatory={true}
          error={modifierGroup?.errors?.baseLanguage?.name}
        />
        <AppSelect
          label={t("Type Selection")}
          options={[
            { value: t("single"), label: t("Single Selection") },
            {
              value: t("multiple"),
              label: t("Multiple Selection"),
            },
          ]}
          value={
            modifierGroup?.values?.isSingleSelection
              ? t("single")
              : t("multiple")
          }
          mandatory={true}
          placeholder={t("Select Type Selection")}
          onChange={(v) => handleSelection("isSingleSelection", v)}
        />
        <AppInput
          label={t("Maximum Selections required by Customer?")}
          value={
            modifierGroup?.values?.isSingleSelection
              ? 1
              : modifierGroup.values.maximumAllowedSelection
          }
          disabled={modifierGroup?.values?.isSingleSelection}
          placeholder={t("Enter Maximum Selections required by Customer?")}
          onInput={(e) =>
            updatePrice("maximumAllowedSelection", e.target.value)
          }
          mandatory={false}
          error={modifierGroup.errors.maximumAllowedSelection}
        />
        <AppInput
          label={t("Minimum Selections required by Customer")}
          value={modifierGroup.values.minimumAllowedSelection}
          placeholder={t("Enter Minimum Selections required by Customer")}
          onInput={(e) =>
            updatePrice("minimumAllowedSelection", e.target.value)
          }
          mandatory={false}
          error={modifierGroup.errors?.minimumAllowedSelection}
        />
      </form>
      {
        content ? 
        <div className="my-4">
          {content}
        </div>
        :null
      }
      </div>
      <SaveBackButton onSave={onSave} showBackButton={showBackButton} as={as} />
    </div>
  );
};

export default GroupModifierForm;
